export default __webpack_public_path__ + "static/media/rotate_right.0c9683c1.svg";